import React from 'react';

import { Typography } from '@mui/material';

import { numberWithCommas } from '@clearverify/utils';

import { VerifierCredentialStatus } from 'src/api';
import { OverviewCredentialedVerifiers } from 'src/types/dashboard';

import { DashboardOverviewBlockListItem } from './DashboardOverviewBlockListItem';

type DashboardOverviewBlockVerifiersProps = {
  verifiers: OverviewCredentialedVerifiers;
  loading: boolean;
};

export const DashboardOverviewBlockVerifiers: React.FC<DashboardOverviewBlockVerifiersProps> = ({
  verifiers,
  loading,
}) => {
  const total = Object.values(verifiers).reduce((acc, curr) => acc + curr, 0);

  return (
    <DashboardOverviewBlockListItem
      loading={loading}
      number={numberWithCommas(total)}
      title="Active Verifiers on the Platform "
      subtitle={
        <React.Fragment>
          <Typography component="span" variant="body2" color="success.main">{`${
            verifiers[VerifierCredentialStatus.Credentialed]
          } Cred.`}</Typography>
          &nbsp;and {verifiers[VerifierCredentialStatus.NotCredentialed]} Not Cred.
        </React.Fragment>
      }
    />
  );
};
